import { FilterBodyListConfig } from '@/components/FilterNew/components/Body/types';
import { FileCategoryEnum, FilePurposeEnum, FileSubCategoryEnum } from '@/types/schema';

import useFilesFilterValue from './useFilesFilterValue';
import useFilesOptionsQuery, { UseFilesOptionsQueryParams } from './useFilesOptionsQuery';

export const FilesEntityConfig: FilterBodyListConfig = {
  listVariant: 'multi-ungrouped-infinite',
  useOptionsQuery: useFilesOptionsQuery,
  useFilterValues: useFilesFilterValue,
};

// NOTE: keep in sync with @/modules/tasks/features/actionItems/hooks/useFileSearch.ts

export const STACKS_QUERY_PARAMS: UseFilesOptionsQueryParams = {
  excludeSystemGenerated: true,
  purpose: [FilePurposeEnum.TaskCategory],
  categories: [FileCategoryEnum.Folder],
};

export const LISTS_QUERY_PARAMS: UseFilesOptionsQueryParams = {
  excludeSystemGenerated: true,
  purpose: [FilePurposeEnum.TaskCategory],
  categories: [FileCategoryEnum.File],
  subCategories: [FileSubCategoryEnum.List],
};

export const PROJECTS_QUERY_PARAMS: UseFilesOptionsQueryParams = {
  excludeSystemGenerated: true,
  purpose: [FilePurposeEnum.TaskCategory],
  categories: [FileCategoryEnum.File],
  subCategories: [FileSubCategoryEnum.Project],
};

/**
 * Please replace notFileIds with your own array when using this query params
 * as it is context specific and cannot be hardcoded here.
 */
export const PROJECTS_WITH_STAGES_QUERY_PARAMS: UseFilesOptionsQueryParams = {
  excludeSystemGenerated: true,
  purpose: [FilePurposeEnum.TaskCategory],
  categories: [FileCategoryEnum.File],
  subCategories: [FileSubCategoryEnum.Project],
  hasStages: true,
  notFileIds: [],
};

export const PROJECTS_AND_LISTS_QUERY_PARAMS: UseFilesOptionsQueryParams = {
  excludeSystemGenerated: true,
  purpose: [FilePurposeEnum.TaskCategory],
  categories: [FileCategoryEnum.File],
  subCategories: [FileSubCategoryEnum.Project, FileSubCategoryEnum.List],
};
